import React, {useState} from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {makeStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import {removeQuery} from "../utils/func";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";


const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        margin: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: '13px',
        top: '13px',
        color: 'black',
    },
    titleWrapper: {
        color: '#424242',
        paddingLeft: '2rem',
    },
    contentWrapper: {
        maxWidth: '300px',
        paddingBottom: '32px',
    },
    huskyImg: {
        textAlign: 'center',
        // width: 'auto',
        // height: '160 * 1.333983106 px',
        height: '149px',
        // 横:縦 = 3953: 6096 = 1: 1.542119909
        marginBottom: '1rem', // アクションがない時つける
    },
    sekkenImg: {
        textAlign: 'center',
        width: 'auto',
        // height: '160 * 1.333983106 px',
        height: '130px',
        // 横:縦 = 3953: 6096 = 1: 1.542119909
        marginBottom: '1rem',
    },
    layerImage: {
        textAlign: 'center',
        width: '120px',
        height: '185.05438908px',
        position: 'relative',
    },
    overlapImage: {
        height: '90px',
        position: 'absolute',
        bottom: '130px',
        left: '170px',
    },
    link: {
        textDecoration: 'none',
        color: 'blue',
    },
    radius: {
        borderRadius: '30%'
    },
}))

const PopUpDialog = () => {
    const classes = useStyles()

    // const currentUrl = window.location.href
    const currentUrl = removeQuery(window.location.href)
    const isEnglish = currentUrl.slice(-2) === '/e' || currentUrl.slice(-2) === '_e'

    const huskyImg = 'images/under-construction.png'
    const huskyApo = 'images/husky_apo.png'
    const rainImg = 'images/rain_0.png'
    const huskyCart = 'images/cart_husky.png'
    const stopPoll = 'images/stop_poll.png'
    const rothiImg = 'images/dec_rothi.png'
    const huskyHappy = 'images/husky_happy.png'
    const sekken = 'images/sekken.png'
    const inviteHusky = 'images/invite_husky.png'
    const footerImage = 'images/husky_apo.png'
    const chikenImage = 'images/rothi_png.png'
    const freeTrack = 'images/free_track.png'
    const tenPersentOff = 'images/tenPercentOff.png'
    const coupon = 'images/coupon.png'
    const costcoInfo = 'images/costco_info.png'
    const closedImg = 'images/dec_closed.png'
    const discountImg = 'images/discount.png'
    const starImg = 'images/star.png'
    const giaImg = 'images/gia.png'
    const feeUpdate = 'images/fee_update.png'
    const outOfStockChiken = 'images/out_of_stock_chiken.png'
    const freeDeliveryBlue = 'images/free-delivery-blue.png'
    const creditCard = 'images/credit_card.png'
    const moneyBack = 'images/money-back.png'
    const fivePercentOff = "images/fivePercentOff.png"
    const coupon_popup = "images/coupon_popup.png"

    const [open, setOpen] = React.useState(true)
    // const {open, setOpen} = props
    const handleClose = () => {
        setOpen(false)
    }
    // const scrollToAvailableArea = () => {
    //     document.body.scrollTop = document.documentElement.scrollTop = 480
    //     handleClose()
    // }

    const [activeStep, setActiveStep] = useState(0)

    return (
        <div>
            <Dialog
                maxWidth='lg'
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div style={{border: '7px solid #afeeee'}}>
                    <IconButton className={classes.closeButton} onClick={() => handleClose()}>
                        <CloseIcon/>
                    </IconButton>

                    <DialogTitle id="alert-dialog-title" className={classes.titleWrapper}>
                        <Typography style={{fontSize: '20px'}}>
                            {isEnglish ? 'NEWS' : '最新情報'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent className={classes.contentWrapper} style={{paddingTop: "0px"}}>
                        {activeStep === 0 &&
                            <div>
                                <DialogContentText
                                    style={{whiteSpace: 'pre-wrap', width: '250px', textAlign: 'center'}}>
                                    <p style={{color: '#424242'}}>
                                        {isEnglish ?
                                            'Notice of Service Termination\nEnd date: June 30, 2025\n\n■ '
                                            :
                                            '当サービス終了のお知らせ\n終了日：2025年6月30日\n\n■ '
                                        }
                                        <a href={isEnglish ?
                                            'https://hubmedia.co.jp/costco/costco-news/husky-cart-service-stop-e/'
                                            :
                                            'https://hubmedia.co.jp/costco/costco-news/husky-cart-service-stop/'}
                                           target='_blank'
                                           rel="noopener noreferrer"
                                           style={{color: 'blue', textDecoration: 'none'}}>
                                            {isEnglish ? 'Click here for detail.' : '詳細はこちら'}
                                        </a>
                                    </p>

                                </DialogContentText>
                                {/*<div style={{textAlign: 'center', marginBottom: '2rem'}}>*/}
                                <div style={{textAlign: 'center'}}>
                                    <img src={huskyApo} alt="under-construction" className={classes.huskyImg}
                                         style={{marginTop: '0', marginBottom: '0'}}/>
                                </div>
                            </div>
                        }

                        {activeStep === 1 &&
                            <div>
                                <DialogContentText
                                    style={{whiteSpace: 'pre-wrap', width: '250px', textAlign: 'center'}}>
                                    <p style={{color: '#424242'}}>
                                        {isEnglish ?
                                            'You can get a discount coupon\naccording to the usage amount!\n\n■ '
                                            :
                                            '現在ご購入金額に応じて\n割引クーポンを還元中です！\n\n■ '
                                        }
                                        <a href={isEnglish ?
                                            'https://costco-johokan.com/costco-news/what-is-huskycart-e/#st-toc-h-8'
                                            :
                                            'https://costco-johokan.com/costco-news/what-is-huskycart/#st-toc-h-8'}
                                           target='_blank'
                                           rel="noopener noreferrer"
                                           style={{color: 'blue', textDecoration: 'none'}}>
                                            {isEnglish ? 'Click here for detail.' : '詳細はこちら'}
                                        </a>
                                    </p>

                                </DialogContentText>
                                {/*<div style={{textAlign: 'center', marginBottom: '2rem'}}>*/}
                                <div style={{textAlign: 'center'}}>
                                    <img src={moneyBack} alt="under-construction" className={classes.huskyImg}
                                         style={{marginTop: '0', marginBottom: '0'}}/>
                                </div>
                            </div>
                        }


                        <DialogActions style={{justifyContent: 'space-between'}}>
                            <Button
                                onClick={() => setActiveStep(activeStep - 1)}
                                color="default"
                                disabled={activeStep === 0}
                                variant='contained'>
                                {isEnglish ? 'back' : '前へ'}
                            </Button>
                            <p style={{opacity: '0.54'}}>&lt; {activeStep + 1} / 2 &gt;</p>
                            <Button
                                onClick={() => setActiveStep(activeStep + 1)}
                                color="default"
                                disabled={activeStep === 1}
                                variant='contained'>
                                {isEnglish ? 'next' : '次へ'}
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </div>
            </Dialog>
        </div>
    )

}

export default PopUpDialog